import { css } from 'styled-components';

export const formModalStyles = css`
  .modal-fullscreen-mobile {
    @media (max-width: 768px) {
      .ant-modal {
        max-width: 100vw;
        margin: 0;
        top: 0;
        padding: 0;
      }
      .ant-modal-content {
        min-height: 100vh;
        border-radius: 0;
        background-color: ${({ theme }) => theme.colors.surface};
      }
      .ant-modal-body {
        max-height: calc(100vh - 110px);
        overflow-y: auto;
      }
    }
  }

  /* Modal de documentação em tela cheia (toggle no header) */
  .modal-docs-fullscreen {
    .ant-modal {
      top: 0;
      margin: 0;
      padding: 0;
      width: 100% !important;
      max-width: 100%;
      height: 100vh;
    }
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      height: 100vh;
      border-radius: 0;
      background-color: ${({ theme }) => theme.colors.surface};
    }
    /* Header sempre visível no topo (X + botão restaurar) */
    .ant-modal-header {
      flex: 0 0 auto;
    }
    .ant-modal-body {
      flex: 1 1 auto;
      max-height: none;
      overflow-y: auto;
    }
    /* Folga lateral do conteúdo da doc em tela cheia (não colar nas bordas) */
    .ant-modal-body .swagger-ui {
      padding-left: 32px;
      padding-right: 32px;
    }
  }

  /* Botão "tela cheia" da doc - espelha o X (.ant-modal-close): mesma cor,
     tamanho e alinhamento, posicionado imediatamente à esquerda do X. */
  .docs-modal-expand {
    position: absolute;
    top: 0;
    right: 54px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    padding: 0;
    line-height: 1;
    color: ${({ theme }) => theme.colors.text.muted};
    background: transparent;
    border: 0;
    outline: 0;
    cursor: pointer;
    transition: color 0.3s;
  }
  .docs-modal-expand:hover,
  .docs-modal-expand:focus {
    color: ${({ theme }) => theme.colors.text.primary};
  }
  /* Botão "abrir em nova aba" - fica à esquerda do botão de tela cheia. */
  .docs-modal-newtab {
    right: 108px;
  }

  /* Dark mode modal body text color */
  .ant-modal-body {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  /* Modal de exemplo: header alto o bastante para a linha ficar abaixo
     dos ícones (X / expandir, ~54px), sem grudar neles. */
  .spk-example-modal .ant-modal-header {
    min-height: 56px;
    display: flex;
    align-items: center;
  }

  /* Fullscreen TOTAL: ocupa a viewport inteira, por cima do header e do footer
     do site. Usado pelo modal de exemplo (cliente) e pelo editar (admin). */
  .spk-modal-fullscreen {
    .ant-modal {
      top: 0;
      padding-bottom: 0;
      margin: 0;
      width: 100vw !important;
      max-width: 100vw;
    }
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      height: 100vh;
      border-radius: 0;
    }
    .ant-modal-body {
      flex: 1 1 auto;
      max-height: none;
      overflow-y: auto;
    }
  }
`;
